import { React, Component, Icon, Config, _ } from 'utils';
import { Creators } from 'model';
import './campaign-styles.less';
import moment from 'moment/src/moment';

export default class Campaing extends Component {

	handleRename = (e) => {

		e.preventDefault();

		var { model } = this.props;
		Creators.editCampaign(model);
	}

	handleDelete = (e) => {
		e.preventDefault();

		var { model } = this.props;
		Creators.deletingCampaign(model);
	}
	handleUserMap = (e) => {
		e.preventDefault();

		var { model } = this.props;
		Creators.createdUserMap(model);
	}
	render() {
		var { model } = this.props;

		var { id, published, title, count, applications } = model;
		var name = 'file';
		var vTitle = <span>{title}</span>
		var wrench = '';

		if(model.loading === true) {
			name = 'fa-hourglass-o';

		} else if(model.type === 'db') {
			name = 'fa-folder-o'
		}

		if(model.loading !== true) {
			vTitle = <a href={ '/hercul/jobs/' + model.id + '/applications' }>{title} <span className="app-count">({ applications})</span></a>;
		}
		let userMap = null;
		if(Config.isAdmin) {
			userMap = <li><a href="#" onClick={this.handleUserMap}>{_('Dodijeli mapu korisniku')}</a></li>
		}

		return <div className="item">
			<div className="icon-panel">
				<i className={'fa ' + name + ' gray'}></i>
				<div className="icon-body">
					<div className="published">{ moment(published).format('DD.MM.YYYY')}</div>
					<h5>{vTitle}</h5>

					<div className="btn-group">
						<div className="btn dropdown-toggle" data-toggle="dropdown">{' '}<i className="fa fa-ellipsis-h"></i></div>
						<ul className="dropdown-menu dropdown-menu-right">
							<li><a href="#" onClick={this.handleRename}>{_('Promijeni naziv')}</a></li>
							<li><a href="#" onClick={this.handleDelete}>{_('Obriši mapu')}</a></li>
							{userMap}
						</ul>
					</div>
				</div>
			</div>
		</div>;
	}
}



// WEBPACK FOOTER //
// ./src/modules/campaign/campaign.js